import { Encumbrance } from 'types';

export const getPartnerEncumbrancePercent = (
  partnerId: string,
  encumbrances: Encumbrance[]
): number => {
  if (!encumbrances || encumbrances.length === 0) return 0;

  let percent = 0;

  encumbrances.forEach((encumbrance) => {
    const coOwner = encumbrance.coOwners.find(
      (coOwner) => coOwner.partner === partnerId
    );

    if (coOwner?.percent) {
      percent += coOwner.percent;
    }
  });

  return percent;
};
